<template>
  <div class="component_container">
    <button class="recordButton" @touchstart="startRecord" @touchend="stopRecord">按住&nbsp;说话</button>

    <van-popup v-model="showRecord" class="popupBackground" style="background: rgba(0,0,0, 0)">
      <div class="flex-col align-center">
        <div class="voice justify-center align-center">
          <van-loading size="40" v-if="!longPress" />
          <img class="voice_gif" :src="voice" alt="加载中..." v-else />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { wxAudioRecord } from "../util/wxAudioRecord";

export default {
  name: "recodeButton",
  computed: {
    wxAudioRecord() {
      return wxAudioRecord
    },
  },
  props: {
    currentComment: {
      type: Object,
    },
    saveRecordComment: {
      type: Function
    },
    getRecordText: {
      type: Function
    }
  },
  data() {
    return {
      voice: "https://static.nationaiot.com/source/zmxcl_assets/GuideStep/voice.gif",
      showRecord: false,
      recordTimeout: null,     //录音延时器
      longPress: false,        //长按

      startRecordTimeout: 2000, //启动录音超时时间
    }
  },
  methods: {
    // 清楚延时器
    clearTime() {
      if (this.recordTimeout != null) clearTimeout(this.recordTimeout);
      this.recordTimeout = null;
    },

    // 开始录音
    startRecord() {
      console.log('长按开始录音');
      if(this.saveRecordComment){
        this.saveRecordComment(this.currentComment);
      }
      this.clearTime();
      this.showRecord = true;
      this.recordTimeout = setTimeout(() => {
        this.wxAudioRecord.startRecording(this.changeRecordState, this.getRecordMsg, this.startRecordTimeout)
      }, 600)
      return false;
    },

    //结束录音
    stopRecord() {
      console.log('结束录音');
      this.showRecord = false;
      this.clearTime();
      if(!this.longPress)
        return this.$toast.fail('请长按说话');
      this.wxAudioRecord.stopRecording(this.changeRecordState, this.getRecordMsg);
      return false;
    },

    // 获取上传的文字和语音
    getRecordMsg(words, audio) {
      this.getRecordText(words);
    },

    // 在录音执行过程中切换状态
    changeRecordState( longPressState, currentHandle) {
      this.longPress = longPressState;
      if(currentHandle == "stopRecord" || currentHandle == "startRecord:fail"){
        console.log('关闭录音框', currentHandle);
        this.showRecord = false;
      }
    },
  }
}
</script>

<style scoped>
.component_container{
  width: 100%;
}
.recordButton{
  width: 100%;
  border-radius: 5px;
  font-size: 14px;
  color: white;
  background: #409EFF;
  padding: 12px 20px;
  text-align: center;
  border: 0;
}
.voice{
  width: 180px;
  height: 80px;
  border-radius: 20px;
  background-color:white;
}
.voice_gif{
  width: 180px;
  height: 33px;
}
</style>



// WEBPACK FOOTER //
// src/components/recodeButton.vue